// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GenderSelect-module__root__CKpB5 {
    width: 340px;
}

@media (max-width: 48em) {
    .GenderSelect-module__root__CKpB5 {
        width: 280px;
    }
}

.GenderSelect-module__root__CKpB5 .GenderSelect-module__control__QRc4k {
    background-color: var(--mantine-color-gray-1);
}

.GenderSelect-module__root__CKpB5 .GenderSelect-module__label__Rx5Mw {
    font-weight: 500;
}

.GenderSelect-module__error__O901Q .GenderSelect-module__control__QRc4k {
    border: 1px solid var(--mantine-color-red-6);
    background-color: var(--mantine-color-red-0);
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/components/form/GenderSelect/GenderSelect.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,4CAA4C;AAChD","sourcesContent":[".root {\n    width: 340px;\n}\n\n@media (max-width: 48em) {\n    .root {\n        width: 280px;\n    }\n}\n\n.root .control {\n    background-color: var(--mantine-color-gray-1);\n}\n\n.root .label {\n    font-weight: 500;\n}\n\n.error .control {\n    border: 1px solid var(--mantine-color-red-6);\n    background-color: var(--mantine-color-red-0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `GenderSelect-module__root__CKpB5`,
	"control": `GenderSelect-module__control__QRc4k`,
	"label": `GenderSelect-module__label__Rx5Mw`,
	"error": `GenderSelect-module__error__O901Q`
};
module.exports = ___CSS_LOADER_EXPORT___;
